import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import rootLogger from '@/utils/root-logger';
import windowUtils from '@/utils/window-utils';

const logger = rootLogger.create('error-reporter');

const initialize = (env) => {
  if (env.sentryio.dsn) {
    Raven
      .config(env.sentryio.dsn, env.sentryio.options)
      .addPlugin(RavenVue, Vue)
      .install();
  }

  windowUtils.getWindow().addEventListener('unhandledrejection', (error) => {
    logger.error('uncaught promise rejection', {
      reason: error.reason, stack: error.reason.stack, promise: error.promise, error
    });
  });
};

const vueErrorCaptured = (err, vm, info) => {
  const vmoptions = vm ? vm.$options : '<vm undefined>';
  const componentName = vm && vm.$options ? vm.$options.name : '<unknown>';
  const componentTag = vm && vm.$options ? vm.$options._componentTag : '<unknown>'; // eslint-disable-line no-underscore-dangle
  logger.error('uncaught vue error', {
    info, componentName, componentTag, vmoptions, err
  });
};

const setContext = (context) => {
  Raven.setTagsContext(context); // appends tags to current context
};

export default {
  initialize,
  setContext,
  vueErrorCaptured
};
